import React from 'react';
import { Tabs, Tab } from '@mui/material';
import './SidebarTabs.css';

interface SidebarTabsProps {
  tabs: string[];
  activeTab: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
  isHorizontal?: boolean;
  disabledTabs?: number[]; 
}

export default function SidebarTabs({ tabs, activeTab, onChange, isHorizontal, disabledTabs = [] }: SidebarTabsProps) {
  return (
    <Tabs
      orientation={isHorizontal ? 'horizontal' : 'vertical'}
      value={activeTab}
      onChange={onChange}
      className={isHorizontal ? 'modal-tabs-horizontal' : 'modal-sidebar'}
      variant="scrollable"
      scrollButtons="auto"
      TabIndicatorProps={{ style: { display: 'none' } }}
    >
      {tabs.map((label, index) => (
        <Tab
          key={index}
          label={label}
          className={disabledTabs.includes(index) ? "modal-tab-item-disabled" : "modal-tab-item"}
          disabled={disabledTabs.includes(index)}
        />
      ))}
    </Tabs>
  );
}
